function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _g, _defs;
var _excluded = ["decorative", "title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagUk(props) {
  var _props = props,
    decorative = _props.decorative,
    title = _props.title,
    titleId = _props.titleId,
    desc = _props.desc,
    descId = _props.descId,
    filteredProps = _objectWithoutProperties(_props, _excluded);
  props = _objectSpread(_objectSpread({}, filteredProps), {}, {
    focusable: false
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-uk_svg__flag-uk_svg__clip0_21417_42814)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24.67v16H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M13.877 0h-3.084v6.5H0v3h10.793V16h3.084V9.5H24.67v-3H13.877V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M18.974 10.782l5.696 3.079v-3.079h-5.696zm-3.957 0L24.67 16v-1.476l-6.924-3.742h-2.73zM22.099 16l-7.082-3.828V16h7.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.017 10.782L24.67 16v-1.476l-6.924-3.742h-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M15.017 10.782L24.67 16v-1.476l-6.924-3.742h-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M4.353 10.783L0 13.135v-2.352h4.353zm5.3.663V16H1.228l8.425-4.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.924 10.782L0 14.524V16l9.653-5.218h-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M5.696 5.217L0 2.14v3.078h5.696zm3.957 0L0 0v1.475l6.924 3.742h2.73zM2.571 0l7.082 3.828V0H2.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.653 5.217L0 0v1.475l6.924 3.742h2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M9.653 5.217L0 0v1.475l6.924 3.742h2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M20.317 5.217l4.353-2.352v2.352h-4.353zm-5.3-.663V0h8.425l-8.425 4.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M17.746 5.217l6.924-3.742V0l-9.653 5.217h2.73z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-uk_svg__flag-uk_svg__clip0_21417_42814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.67,
    height: 16,
    fill: "#fff",
    rx: 2
  })))));
}
export default SvgFlagUk;